<div class="top-strip">
  <div class="container">
    <span>International Oilfield Supply & Industrial Services</span>
    <span class="top-country-links">
        <a routerLink="/contact" [queryParams]="{ office: 'UK' }">UK</a>
        <b>|</b>
        <a routerLink="/contact" [queryParams]="{ office: 'Qatar' }">Qatar</a>
        <b>|</b>
        <a routerLink="/contact" [queryParams]="{ office: 'Azerbaijan' }">Azerbaijan</a>
        <b>|</b>
        <a routerLink="/contact" [queryParams]="{ office: 'Kazakhstan' }">Kazakhstan</a>
        <b>|</b>
        <a routerLink="/contact" [queryParams]="{ office: 'Georgia' }">Georgia</a>
    </span>
    <div class="top-social">
        <ng-container *ngTemplateOutlet="socialLinksTemplate"></ng-container>
    </div>
  </div>
</div>

<header class="navbar">
  <div class="container nav-inner">
    <a class="brand" routerLink="/" (click)="closeMenu()">
      <img src="assets/img/logo.png" alt="IOSC Global Logo" class="brand-logo">
      <span class="brand-text">IOSC<br><small>GLOBAL SUPPLY</small></span>
    </a>

    <nav class="nav-links" [class.open]="menuOpen">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="closeMenu()">Home</a>
      <a routerLink="/about" routerLinkActive="active" (click)="closeMenu()">About</a>
      <a routerLink="/services" routerLinkActive="active" (click)="closeMenu()">Services</a>
      <a href="/products" routerLinkActive="active" (click)="openAllProducts($event)">Products</a>
      <a routerLink="/certificates" routerLinkActive="active" (click)="closeMenu()">Certificates</a>
      <a routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">Contact</a>
    </nav>

    <div class="nav-actions">
      <a class="btn btn-ghost" href="/products" (click)="openAllProducts($event)">Catalog</a>
      <a class="btn btn-primary" routerLink="/contact">Request Quote</a>
      <button class="burger" type="button" (click)="toggleMenu()">â˜°</button>
    </div>
  </div>
</header>

<router-outlet></router-outlet>

<footer class="footer">
  <div class="container">
    <div class="footer-grid">
      <div>
        <a class="brand" routerLink="/">
          <img src="assets/img/logo.png" alt="IOSC Global Logo" class="brand-logo">
          <span class="brand-text">IOSC<br><small>GLOBAL SUPPLY</small></span>
        </a>
        <p>International oilfield supply, industrial services and project procurement support.</p>
      </div>

      <div>
        <h4>Company</h4>
        <a routerLink="/about">About</a><br>
        <a routerLink="/services">Services</a><br>
        <a routerLink="/products">Products</a><br>
        <a routerLink="/certificates">Certificates</a>
      </div>

      <div>
        <h4>Services</h4>
        <a>Warehousing</a><br>
        <a>Rental</a><br>
        <a>Manufacturing</a><br>
        <a>Testing</a>
      </div>

      <div>
        <h4>Request</h4>
        <p>Send your RFQ and our team will respond with availability and pricing.</p>
        <a class="btn btn-primary" routerLink="/contact">Request Quote</a>
      </div>

      <div class="footer-social">
          <h4>Follow IOSC</h4>
          <p>Connect with IOSC Global through official social channels.</p>
          <ng-container *ngTemplateOutlet="socialLinksTemplate"></ng-container>
      </div>
    </div>

    <div class="footer-bottom">
      <span>Â© 2026 IOSC Global. All rights reserved.</span>
      <span><a routerLink="/certificates">Certificates</a> / <a routerLink="/contact">RFQ</a></span>
    </div>
  </div>
</footer>
<ng-template #socialLinksTemplate>
    <div class="social-links" aria-label="Social media links">
        <a *ngFor="let s of socialLinks"
           [href]="s.url || '#'"
           [target]="getTarget(s.url)"
           [attr.aria-label]="s.name"
           [title]="s.name">

            <svg *ngIf="s.iconKey === 'linkedin'" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.3 8.1h4.4V23H.3V8.1zM8.1 8.1h4.2v2.04h.06c.58-1.1 2-2.26 4.13-2.26 4.42 0 5.24 2.9 5.24 6.68V23h-4.4v-7.49c0-1.79-.03-4.08-2.49-4.08-2.49 0-2.87 1.94-2.87 3.95V23H8.1V8.1z" />
            </svg>

            <svg *ngIf="s.iconKey === 'facebook'" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M22 12.06C22 6.48 17.52 2 11.94 2S2 6.48 2 12.06c0 5.02 3.66 9.19 8.44 9.94v-7.03H7.9v-2.91h2.54V9.84c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.2 2.23.2v2.45h-1.26c-1.24 0-1.62.77-1.62 1.56v1.89h2.76l-.44 2.91h-2.32V22c4.78-.75 8.44-4.92 8.44-9.94z" />
            </svg>

            <svg *ngIf="s.iconKey === 'instagram'" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2zm0 2A3.8 3.8 0 0 0 4 7.8v8.4A3.8 3.8 0 0 0 7.8 20h8.4a3.8 3.8 0 0 0 3.8-3.8V7.8A3.8 3.8 0 0 0 16.2 4H7.8zm8.95 1.75a1.35 1.35 0 1 1 0 2.7 1.35 1.35 0 0 1 0-2.7zM12 7.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6zm0 2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6z" />
            </svg>

            <svg *ngIf="s.iconKey === 'youtube'" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M23.5 6.2a3.02 3.02 0 0 0-2.13-2.14C19.49 3.55 12 3.55 12 3.55s-7.49 0-9.37.51A3.02 3.02 0 0 0 .5 6.2 31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3.02 3.02 0 0 0 2.13 2.14c1.88.51 9.37.51 9.37.51s7.49 0 9.37-.51a3.02 3.02 0 0 0 2.13-2.14A31.5 31.5 0 0 0 24 12a31.5 31.5 0 0 0-.5-5.8zM9.6 15.6V8.4L15.84 12 9.6 15.6z" />
            </svg>

            <svg *ngIf="s.iconKey === 'email'" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M3 5h18a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm9 8.15L3.4 7H3v.4l9 6.45 9-6.45V7h-.4L12 13.15z" />
            </svg>

            <span *ngIf="
        s.iconKey !== 'linkedin' &&
        s.iconKey !== 'facebook' &&
        s.iconKey !== 'instagram' &&
        s.iconKey !== 'youtube' &&
        s.iconKey !== 'email'
      ">
                {{ s.name ? s.name.charAt(0) : '?' }}
            </span>

        </a>
    </div>
</ng-template>


